import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=2e279df2&scoped=true"
import script from "./input-date.ts?vue&type=script&lang=ts&external"
export * from "./input-date.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e279df2",
  null
  
)

export default component.exports